angular
  .module 'shared'
  .factory 'roundMinutes', ->
    (time, interval) ->
      remainder = (interval - time.minute()) % interval
      remainder += interval if remainder < 0

      moment(time).add(remainder, "minutes").set({'second': 0})
